<batch-notification
  header="ERP_REPORT_FAILED_TO_UPLOAD"
  hint="THERE_WAS_AN_ERROR_WHILE_UPLOADING_ITEMS_IN_ERP_REPORT"
  isShowReload="true"
  isError="true"
  isShowContactSupport="true"
  [downloadUrl]="batchItem.fileReference"
  (reload)="onReload()"
></batch-notification>
